var ScheduleSearch = (function ($) {
    ScheduleSearch = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        that.$form_wrapper = options["$form_wrapper"];
        that.$list_wrapper = options["$list_wrapper"];
        that.$load_more_wrapper = that.$wrapper.find(".js-load-more-wrapper");

        that.$departure_input = that.$wrapper.find(".js-departure");
        that.$arrival_input = that.$wrapper.find(".js-arrival");
        that.$swap_direction = that.$wrapper.find(".js-swap-direction");
        that.$date_forth_input = that.$wrapper.find(".js-date-forth");
        that.$date_back_input = that.$wrapper.find(".js-date-back");
        that.$show_connecting_flights_checkbox = that.$wrapper.find(".js-schedule-show-connecting-flights-checkbox");

        that.$flight_type_drawer = that.$wrapper.find(".js-flight-type-drawer");

        that.$submit = that.$wrapper.find(".js-submit");

        // SELECTOR
        that.select_flight = {
            wrapper: ".js-flight-wrapper",

            flight_route: ".js-flight-route",
            flight_duration: ".js-flight-duration",
        };
        
        that.select_variant = {
            wrapper: ".js-variant-wrapper",
            localtime_disclaimer: '.js-drawer-localtime-disclaimer',
            price_buttons_wrapper: '.js-variant-price-buttons-wrapper',

            transfer: ".js-variant-transfer",
            transfer_duration: ".js-variant-transfer-duration",
            transfer_warning: ".js-variatn-transfer-warning",

            logo: '.js-variant-logo',
            company_name: '.js-variant-company',
            flight_number: '.js-variant-flight-number',
            aircraft: '.js-variant-aircraft',

            departure_time: ".js-variant-departure-time",
            departure_city: ".js-variant-departure-city",
            departure_airport: ".js-variant-departure-airport",
            departure_code: ".js-variant-departure-code",
            departure_date: ".js-variant-departure-date",

            arrival_time: ".js-variant-arrival-time",
            arrival_city: ".js-variant-arrival-city",
            arrival_airport: ".js-variant-arrival-airport",
            arrival_code: ".js-variant-arrival-code",
            arrival_date: ".js-variant-arrival-date",
        };

        // DYNAMIC VARS
        that.timer = null;
        that.params = {};
        that.flight_more_next_day = false
        
        // CONST
        that.locale = options["locale"];
        that.locales = options["locales"] || {};
        that.airports = options["airports"] || {};

        // INIT
        that.init();
    };

    ScheduleSearch.prototype.init = function () {
        var that = this;

        that.initWorker();

        that.initDateInputs();

        that.initSwapDirection();

        that.initDrawer();

        that.initSubmit();
        
        that.disableEmptyLinks();
    };

    ScheduleSearch.prototype.initPagination = function () {
        var that = this,
            url = new URL(window.location.href);
        $.sa.pagination(that.$wrapper, url.toString());
    };

    ScheduleSearch.prototype.initSubmit = function () {
        var that = this;

        that.$submit.on("click", function () {
            that._refreshPageWithNewSearchParams(that.params);
        });
    };
    
    ScheduleSearch.prototype.disableEmptyLinks = function () {
        var that = this;

        that.$wrapper.find("a[href*='#']").on("click", function (event) {
            event.preventDefault();
        });
    }

    ScheduleSearch.prototype._refreshPageWithNewSearchParams = function (
        params
    ) {
        var that = this,
            url = new URL(window.location.href);
        
        $.each(params, function (index, value) {
            if(value.toString().length > 0) {
                url.searchParams.set(index, value.toString());
            } else {
                url.searchParams.delete(index);
            }
        });

        that.$form_wrapper.find("*").prop("disabled", true);
        $.sa.content_router.load(url.toString());
    };

    ScheduleSearch.prototype.initWorker = function () {
        var that = this;

        that.$departure_input.on("input", function () {
            var query = $.trim(that.$departure_input.val().toLowerCase());
            var param_name = that.$departure_input.attr("name") ?? "departure";

            that.params = Object.assign(that.params, {
                [param_name]: query,
            });
        });

        that.$arrival_input.on("input", function () {
            var query = $.trim(that.$arrival_input.val().toLowerCase());
            var param_name = that.$arrival_input.attr("name") ?? "arrival";

            that.params = Object.assign(that.params, {
                [param_name]: query,
            });
        });

        that.$show_connecting_flights_checkbox.on("change", function () {
            $_changed_element = $(this);
            var param_name =
                that.$show_connecting_flights_checkbox.attr("name") ?? "show_connecting_flights";
            that._refreshPageWithNewSearchParams({
                [param_name]: $_changed_element.prop("checked")  ? 1 : 0
            });
        });
    };

    ScheduleSearch.prototype.initDateInputs = function () {
        var that = this;

        that.ui_calendar_input = $.uiCalendarInput({
            $date_first_input: that.$date_forth_input,
            $date_second_input: that.$date_back_input,
            month_first: $.sa.server_datetime,
            month_count: 12,
            title: $.sa.locales["select_dates"],
            onDaySelect: function onDaySelect() {
                var param_name_to = that.$date_forth_input.attr("name") ?? "date";
                var param_name_from = that.$date_back_input.attr("name") ?? "return_date";

                var date = $.trim(that.$date_forth_input.data("value"));
                var return_date = $.trim(that.$date_back_input.data("value"));

                that.params = Object.assign(that.params, {
                    [param_name_to]: date,
                    [param_name_from]: return_date,
                });
            },
        });
    };

    ScheduleSearch.prototype.initSwapDirection = function () {
        var that = this;

        that.$swap_direction.on("click", function () {
            var allowed = !that.$swap_direction.attr("disabled");

            if (allowed) {
                var departure_code = that.$departure_input.val(),
                    arrival_code = that.$arrival_input.val();

                that.$departure_input.val("");
                that.$arrival_input.val("");

                setTimeout(function () {
                    that.$departure_input.val(arrival_code).trigger("change");
                    that.$arrival_input.val(departure_code).trigger("change");
                    // TODO фокус на поле $arrival_input = that.$arrival_input.parents('div.select').first().find('input[type=text]')
                }, 0);
            }
        });

        // валидация возможности обратных рейсов
        var swap_available = function () {
            var arrival_code = that.$arrival_input.val(),
                departure_code = that.$departure_input.val(),
                $select = that.$arrival_input.parents("div.select").first(),
                $selected = $select.find('.select-options .option[data-value="' + arrival_code + '"]').first(),
                to = $selected.data("to") || [],
                swap_available = departure_code && arrival_code && (to.indexOf(departure_code) !== -1);
            // some glitches at select, so swap available only on filled fields

            that.$swap_direction.attr("disabled", swap_available ? null : true);
        };

        that.$arrival_input.on("change", swap_available);
        that.$departure_input.on("change", swap_available);

        // подфильтрация направлений
        var filter_arrival = function () {
            var departure_code = that.$departure_input.val(),
                selected_arrival_code = that.$arrival_input.val(),
                arrival_code_available = false,
                $select = that.$arrival_input.parents("div.select").first(),
                $arrival_input = $select.find("input[type=text]");

            $select.find(".select-options .option").map(function () {
                var $option = $(this),
                    from = $option.data("from"),
                    arrival_code = $option.data("value"),
                    is_hidden = departure_code && (from.indexOf(departure_code) === -1);

                $option.data("hidden", is_hidden);
                if (is_hidden) {
                    $option.hide();
                } else {
                    if (arrival_code === selected_arrival_code) {
                        arrival_code_available = true;
                    }
                    $option.show();
                }
            });

            if (!arrival_code_available) {
                $arrival_input.val("");
            }
        };
        that.$departure_input.on("change", filter_arrival);

        // инициализация
        swap_available();
        filter_arrival();
    };

    ScheduleSearch.prototype.getVariantTransfer = function (transfer_duration, next_day) {
        var that = this;
        var $variant_tranfer = that.$wrapper.find(that.select_variant.transfer).clone().show();

        $variant_tranfer.find(that.select_variant.transfer_duration).text(transfer_duration);
        if(next_day) {
            $variant_tranfer.find(that.select_variant.transfer_warning).text(that.locales['flight_next_day']);
        }
        return $variant_tranfer;
    }

    ScheduleSearch.prototype.getSegmentTitle = function (flight_data) {
        var that = this;

        var departure_airport = flight_data.route[0].departure_airport;
        var arrival_airport = flight_data.route[flight_data.route.length - 1].arrival_airport;
        var departure_title = that.getAirportData(departure_airport);
        var arrival_title = that.getAirportData(arrival_airport);

        return departure_title.city + ' — ' + arrival_title.city;
    }

    ScheduleSearch.prototype.__drawerSegmentsCall = function ($flight_row) {
        var that = this;

        var $drawer_content = that.$wrapper.find(that.select_variant.wrapper);
        var $body = $("<div>");

        var flight_data = that.getDataRow($flight_row);
        var show_buy_btn = flight_data.duration < 86400;

        var $flight_direct = that.setVariant(
            $drawer_content.clone().show(),
            flight_data.route[0],
        );
        $body.append($flight_direct);

        for (var i = 1; i < flight_data.route.length; i++) {
            var next_day = flight_data.route[i-1]['arrival_date'] !==  flight_data.route[i]['departure_date'];
            var $variant_transfer = that.getVariantTransfer(flight_data._transfer_duration, next_day)
            $body.append($variant_transfer);

            var $flight_non_direct = that.setVariant(
                $drawer_content.clone().show(),
                flight_data.route[i],
            )
            $flight_non_direct.addClass('padding-top-large')
            $body.append($flight_non_direct);
        }

        var $variant_localtime_disclaimer = that.$wrapper.find(that.select_variant.localtime_disclaimer);
        $body.append($variant_localtime_disclaimer.clone().show());

        var $drawer_footer = that.$wrapper.find(that.select_variant.price_buttons_wrapper).clone().show();
        $drawer_footer.find('.js-drawer-buy-btn').prop("href", flight_data._link);
        
        $.uiDrawer({
            position: "right",
            custom_class: "narrow variant-card no-radius drawer-segments",
            header_title: that.getSegmentTitle(flight_data),
            header_description: that.locales['in_path'] + ' ' + flight_data._duration,
            footer: show_buy_btn ? $drawer_footer.html() : null,
            content: $body.html()
        });
    };

    ScheduleSearch.prototype.setVariant = function ($variant, route) {
        var that = this;

        var departure_airport = that.getAirportData(route.departure_airport);
        var arrival_airport = that.getAirportData(route.arrival_airport);

        $variant.find(that.select_variant.logo).attr('src', route.company.icon);
        $variant.find(that.select_variant.logo).attr('alt', route.company.name);
        $variant.find(that.select_variant.company_name).text(route.company.name);
        $variant.find(that.select_variant.flight_number).text(that.locales['flight'] + ' ' + route.number);

        $variant.find(that.select_variant.departure_code).text(route.departure_airport_code);
        $variant.find(that.select_variant.departure_airport).text(departure_airport.name);
        $variant.find(that.select_variant.departure_city).text(departure_airport.city);
        $variant.find(that.select_variant.departure_time).text(route.departure_time);
        $variant.find(that.select_variant.departure_date).text(route._departure_date.weekday + ', ' + route._departure_date.date_month);

        $variant.find(that.select_variant.arrival_code).text(route.arrival_airport_code);
        $variant.find(that.select_variant.arrival_airport).text(arrival_airport.name);
        $variant.find(that.select_variant.arrival_city).text(arrival_airport.city);
        $variant.find(that.select_variant.arrival_time).text(route.arrival_time);
        $variant.find(that.select_variant.arrival_date).text(route._arrival_date.weekday+ ', ' + route._arrival_date.date_month);

        return $variant;
    }

    ScheduleSearch.prototype.getAirportData = function (airport_data) {
        var that = this;

        var city = airport_data.city[that.locale === 'ru' ? 'name_ru' : 'name']
        var name = airport_data[that.locale === 'ru' ? 'name_ru' : 'name']

        return { city, name }
    }

    ScheduleSearch.prototype.getDataRow = function ($flight_type) {
        return JSON.parse(decodeURIComponent($($flight_type).data('flight')));
    };

    ScheduleSearch.prototype.initDrawer = function () {
        var that = this;

        that.$flight_type_drawer.on("click", function () {
            var $flight_row = $(this)

            that.__drawerSegmentsCall($flight_row);
        });
    };

    return ScheduleSearch;
})($);
